import type { ChipProps } from '@mui/material';
import { alpha } from '@mui/material/styles';

export type ActionTone = 'success' | 'error' | 'warning' | 'info' | 'secondary' | 'default';

function actionTone(action: string): ActionTone {
  const normalized = action.trim().toUpperCase();

  if (
    normalized.includes('FAIL') ||
    normalized.includes('ERROR') ||
    normalized.includes('DENIED') ||
    normalized.includes('REJECT') ||
    normalized.includes('DELETE') ||
    normalized.includes('REMOVE') ||
    normalized.includes('DISABLE') ||
    normalized.includes('REVOKE')
  ) {
    return 'error';
  }

  if (
    normalized.includes('SUCCESS') ||
    normalized.includes('CREATE') ||
    normalized.includes('ENABLE') ||
    normalized.includes('APPROVE') ||
    normalized.includes('RESTORE')
  ) {
    return 'success';
  }

  if (
    normalized.includes('UPDATE') ||
    normalized.includes('EDIT') ||
    normalized.includes('PATCH') ||
    normalized.includes('CHANGE')
  ) {
    return 'info';
  }

  if (
    normalized.includes('INVALIDATE') ||
    normalized.includes('RESET') ||
    normalized.includes('EXPIRE') ||
    normalized.includes('WARN')
  ) {
    return 'warning';
  }

  if (normalized.includes('LOGIN') || normalized.includes('AUTH')) {
    return 'secondary';
  }

  return 'default';
}

export function auditActionChipProps(action: string): ChipProps {
  return auditToneChipProps(actionTone(action));
}

/** Outlined chip tinted with a palette tone (the audit console's event chips). */
export function auditToneChipProps(tone: ActionTone): ChipProps {
  if (tone === 'default') {
    return { color: 'default', variant: 'outlined' };
  }

  return {
    color: tone,
    variant: 'outlined',
    sx: (theme) => ({
      bgcolor: alpha(theme.palette[tone].main, theme.palette.mode === 'light' ? 0.08 : 0.18),
      borderColor: alpha(theme.palette[tone].main, 0.55),
      color: theme.palette[tone].main,
      fontWeight: 700,
    }),
  };
}
